import React from 'react';
import { Button, type SxProps, type Theme, useTheme } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { useToggle } from 'usehooks-ts';

import PaperPlaneIcon from '@/assets/icons/paper-plane.svg?react';

import SendInvitationModal from './SendInvitationModal';

const SendInvitation = ({ disabled, sx }: { disabled?: boolean; sx?: SxProps<Theme> }) => {
  const { palette } = useTheme();
  const [isOpen, toggleOpen] = useToggle(false);

  return (
    <>
      <Button
        variant="text-icon"
        onClick={toggleOpen}
        size="large"
        disableRipple={true}
        disabled={disabled}
        startIcon={<PaperPlaneIcon />}
        sx={mergeSx({ color: palette.primary.main }, sx)}
      />
      {isOpen && <SendInvitationModal onClose={toggleOpen} />}
    </>
  );
};

export default SendInvitation;
